import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SearchableListService {
  private selectedItems: Array<any> = [];

  constructor() {}

  public getSelectedItems(): Array<any> {
    return this.selectedItems;
  }

  public setSelectedItems(items: Array<any>): void {
    this.selectedItems = items;
  }
}
